import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {Box,Button, List, ListItem, ListSubheader} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import PhoneInput from "react-phone-number-input/input";

import { checkEddRecordService } from "../service";
import ButtonMailto from "./ButtonMailTo";
import MainTemplate from "./MainTemplate";

import "./Homepage.css"; 

const HomePage = (props) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [invalidPhone, setInvalidPhone] = useState(false);
  const [invalidPhoneErrorMessage, setInvalidPhoneErrorMessage] = useState("");
  const [eddCheckinProgress, setEddCheckinProgress] = useState(false);
  const [documentsNotRequired, setDocumentsNotRequired] = useState(false);
  const [customerUUID, setCustomerUUID] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (customerUUID) {
      navigate(`/upload/${customerUUID}`);
    }
  }, [customerUUID])

  const navigateToUploadFile = async () => {
    if (
      /^[2-9]\d{2}-\d{3}-\d{4}$/.test(phoneNumber) ||
      /^[2-9]\d{2}\d{3}\d{4}$/.test(phoneNumber) ||
      /^\+1[2-9]\d{2}\d{3}\d{4}$/.test(phoneNumber)
    ) {
      let actualNumber = phoneNumber.replace(/-/g, "")
      actualNumber = "\+1" + actualNumber.replace("+1", "")
      await checkEDDRecord(actualNumber);
    } else {
      setInvalidPhone(true);
      setInvalidPhoneErrorMessage("Invalid phone number.");
    }
  };

  const checkEDDRecord = async (number) => {
    setEddCheckinProgress(true);
    try {
      var response = await checkEddRecordService(number);
      let result = await response.json()
      if (response.status !== 200) {
        setInvalidPhone(true);
        setInvalidPhoneErrorMessage("Error fetching Records.");
        return false;
      }
      if (result.documents_required) {
        setCustomerUUID(result.uuid)
        return true;
      }
      setDocumentsNotRequired(true);
      return false;
    } catch (ex) {
      setInvalidPhone(true);
      setInvalidPhoneErrorMessage("Error fetching Records.");
      return false;
    } finally {
      setEddCheckinProgress(false);
    }
  };

  const phoneNumberChange = (value) => {
    if (value) {
      setPhoneNumber(value);
    } else {
      setPhoneNumber("");
    }
    setInvalidPhone(false);
    setInvalidPhoneErrorMessage("");
    setDocumentsNotRequired(false);
  }

  return (
    <MainTemplate>
      <div className="row ">
        <div className="header_boxhome pt-2">
          <span className="header-iconHome">
          {/* <img src="../assets/img/Safe-Secure-Lock.png"></img> */}
          </span>
          <h1 className="headerStyleHome">SECURE DOCUMENT UPLOAD</h1>
        </div>
        <div class="col header_box">
          <span className="safe-icon"></span>
        </div >
        <div className="col center-itemhome">
          <div>
            <label 
              htmlFor="phoneNumber"
              className="py-2"
            >
              ENTER YOUR PHONE NUMBER
            </label>
            <PhoneInput
              style={{backgroundColor:"#fcf7f7" ,height:"3rem", borderColor:"black"}}
              type="tel"
              className={
                invalidPhone
                  ? "form-control border border-danger mb-3 "
                  : "form-control mb-3 "
              }
              size="30"
              id="phoneNumber"
              country="US"
              value={phoneNumber}
              placeholder="(###) ###-####"
              onChange={phoneNumberChange}
            />
            {eddCheckinProgress && (
              <Box sx={{ 
                width: "100%",
                marginBottom: "1rem"
              }}>
                <LinearProgress />
              </Box>
            )}
            {invalidPhone && (
              <div className="mb-3 text-danger col-xs-2">{invalidPhoneErrorMessage}</div>
            )}
            {documentsNotRequired && (
              <div className="mb-3 text-success col-xs-2">
                No documents are required at this time.
              </div>
            )}
            <Button
              component="label"
              style={{ backgroundColor: "#ffc464", color: '#FFFFFF', height:"40px" }}
              onClick={navigateToUploadFile}
            >
              Submit Documents
            </Button>
            <div style={{textAlign:"center", color:"black"}}>
              <div className=" pt-2">Here are some common documents we accept: </div>
            </div>
            <List sx={{ listStyleType: 'disc' }}>
            <ListItem sx={{ display: 'list-item' }}> Bank Statements </ListItem>
            <ListItem sx={{ display: 'list-item' }}> Tax Returns </ListItem>
            <ListItem sx={{ display: 'list-item' }}> Pay Stubs </ListItem>
            <ListItem sx={{ display: 'list-item' }}> Retirement / Investment Account Statements </ListItem>
          </List>
            <div style={{textAlign:"center", color:"black"}}>
              <div className="helpText pt-5">NEED </div>
              <div style={{ marginTop: "20px" }}>
                Bitcoin Depot is here to help!
                <br />
                Call or email for support.
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <a
                  href="tel:678-435-9604"
                  style={{
                    color: "#212529",
                    textDecoration: "none",
                  }}
                >
                  (678)435- 9604
                </a>
                <br />
                <div>
                  <ButtonMailto
                    label="support@bitcoindepot.com"
                    mailto="mailto:support@bitcoindepot.com"
                    black
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainTemplate>
  );
};

export default HomePage;
